import LsdApiModel  from './global/LsdApiModel';
import { computed } from 'mobx';

export default class UserGroupCompanyModel extends LsdApiModel {
	static get path(): string {
		return '/user_group_companies/{?id}';
	}

	@computed
	public get userId() {
		return this.get('user.id');
	}

	@computed
	public get companyId() {
		return this.get('company.id');
	}

	@computed
	public get groupId() {
		return this.get('group.id');
	}
}
